import { render, staticRenderFns } from "./AddGoodsUnit.vue?vue&type=template&id=7ed8cf96&"
import script from "./AddGoodsUnit.vue?vue&type=script&lang=js&"
export * from "./AddGoodsUnit.vue?vue&type=script&lang=js&"
import style0 from "./AddGoodsUnit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports